import { FormattedNumber } from 'react-intl';

import { Cost } from 'components/player/Cost';
import type { unitMapping } from 'lib/style';
import type { Color } from 'style/types';

type Props = {
  value: number;
  size: keyof typeof unitMapping;
  inverted: boolean;
  noBorder: boolean;
};

const getGainColor = (value: number): Color => {
  if (value > 5) return 'var(--c-score-high)';
  if (value >= 1) return 'var(--c-score-medium)';
  if (value > -1) return 'var(--c-nd-400)';
  if (value > -5) return 'var(--c-score-low)';
  return 'var(--c-score-veryLow)';
};

export const Gain = ({ value, size, inverted, noBorder }: Props) => {
  const roundedValue = Math.round(value);
  const color = getGainColor(roundedValue);

  return (
    <Cost
      color={color}
      size={size}
      inverted={inverted}
      noBorder={noBorder}
      score={
        <FormattedNumber
          value={value}
          maximumFractionDigits={0}
          signDisplay="exceptZero"
        />
      }
    />
  );
};
